<template>
  <section class="cn-prose-block">
    <div class="container">
      <article class="prose-custom dark:prose-invert">
        <h1 v-if="title">{{ title }}</h1>
        <div v-html="data"></div>
        <div class="not-prose">
          <slot name="end" />
        </div>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
interface Props {
  data: string;
  title?: string;
}

defineProps<Props>();
</script>

<style lang="scss">
.cn-prose-block {
  .prose-custom {
    padding-top: var(--size-4xl);
    padding-bottom: var(--size-4xl);
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
